import { redirectToUrl } from '@wix/gg-common-lib/utils';
import { getProviderConfig } from 'config/providers';
import { biLogger } from 'hooks';

const WIX_DASHBOARD_URL = 'https://manage.wix.com/dashboard';

interface RedirectToDashboardParams {
  metaSiteId: string;
}

export function buildDashboardUrl(metaSiteId: string): string {
  const { dashboardUrl } = getProviderConfig();

  return dashboardUrl || [WIX_DASHBOARD_URL, metaSiteId].join('/');
}

export async function redirectToDashboard({ metaSiteId }: RedirectToDashboardParams): Promise<void> {
  if (!metaSiteId) {
    console.error('MetaSiteId is required to redirect to dashboard');
    return;
  }

  const dashboardUrl = buildDashboardUrl(metaSiteId);
  biLogger.generateSite(dashboardUrl);
  redirectToUrl(dashboardUrl);
}
